import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import DefaultFormInput from "../../../../../../common/components/default_form_input";

import FormContainer from "../../../../../../common/components/form_container";
import { FormSwitchInput } from "../../../../../../common/components/masked_inputs/react_forms/form_switch_input";
import { CopiarObraAreaChecklistForm, CopiarObraAreaChecklistSchema } from "../../../schemas/Obras_cadastroarea/copiar_obra_area_checklist";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";

/**
 * CopyChecklistAreaModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  onClose: () => void;
  onSubmit: (form: CopiarObraAreaChecklistForm) => void;
};

export const CopyChecklistAreaModal = ({
  open,
  saving,
  loading,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<CopiarObraAreaChecklistForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    resolver: zodResolver(CopiarObraAreaChecklistSchema),
  });

  useEffect(() => {
    if (open) {
      hookForm.reset();
    }
  }, [
    open,
    hookForm,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title='Copiar Checklist de área'
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <FormContainer title="Informações" arrangement="fullRow">
        <>
          <DefaultFormInput
            name='area'
            label='Área'
            required={true}
            reactHookForm={hookForm}
          />
          <div>
            <p>Copiar Checklist?*</p>
            <FormSwitchInput
              name='copiarChecklist'
              activeLabel='Sim'
              inactiveLabel='Não'
              readOnly={saving}
              reactHookForm={hookForm}
            />
          </div>
        </>
      </FormContainer>
    </BaseFormControlledModal>
  );
}